import CategoriesScreen from '../screens/categories'

export default CategoriesScreen
